import { ArrowUpRight } from "lucide-react";
import { SITE } from "@/constants/site";
import { Reveal } from "@/components/Reveal";

export const Reviews = () => (
  <section id="reviews" data-testid="reviews-section" className="border-y border-seam bg-coal">
    <div className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-32">
      <Reveal>
        <p className="mb-4 text-xs font-bold uppercase tracking-[0.35em] text-acid">Reviews</p>
        <h2 className="max-w-4xl font-display text-4xl font-black italic uppercase leading-none tracking-tighter sm:text-5xl lg:text-[5vw]">
          Your word <span className="text-acid">is our reputation.</span>
        </h2>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-zinc-400">
          We’re a small local crew building our name one cleanout at a time — no bought stars, no
          cherry-picked quotes. Real customer reviews will live right here as they come in.
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-12 flex flex-wrap items-center gap-5 border border-seam bg-ink p-8 md:p-10">
          <p className="font-display text-2xl font-extrabold italic uppercase tracking-tight sm:text-3xl">
            Hauled for you before? <span className="text-acid">Tell the neighborhood.</span>
          </p>
          <a
            data-testid="google-review-btn"
            href={SITE.googleReviewUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-acid px-6 py-3.5 font-display text-lg font-extrabold italic uppercase tracking-tight text-black transition-colors duration-200 hover:bg-white"
          >
            Review us on Google <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
